import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Nlayout from './Nlayout';
import { useAuth } from './authContext';
import { Box, Typography, Grid, CircularProgress, Chip } from '@mui/material';
import { TbReceipt, TbCheck, TbX, TbClock, TbSearch, TbFilter } from 'react-icons/tb';
import { FaShield } from 'react-icons/fa6';
import TelegramVerificationCard from './components/TelegramVerificationCard';
import './Rankings.css';

export default function MisSolicitudes({ isMobile }) {
    const { username } = useAuth();
    const nombre = localStorage.getItem('kick_user') || username;
    const [solicitudes, setSolicitudes] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterStatus, setFilterStatus] = useState('ALL'); // ALL, PENDIENTE, ENTREGADA, RECHAZADA
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        if (!nombre) {
            setLoading(false);
            return;
        }
        const fetchSolicitudes = async () => {
            try {
                const { data } = await axios.get(
                    `https://backend.eldenguee.com/solicitudes/${nombre}/mis-solicitudes`
                );
                setSolicitudes(Array.isArray(data) ? data : []);
            } catch (error) {
                console.error("Error cargando solicitudes:", error);
                setSolicitudes([]);
            } finally {
                setLoading(false);
            }
        };
        fetchSolicitudes();
    }, [nombre]);

    // Calculate metrics
    const totalCount = solicitudes.length;
    const entregadasCount = solicitudes.filter(s => {
        const est = (s.status || '').toLowerCase();
        return est === 'accepted' || est.includes('entregad') || est.includes('aprobad');
    }).length;
    const rechazadasCount = solicitudes.filter(s => {
        const est = (s.status || '').toLowerCase();
        return est === 'rejected' || est.includes('rechazad') || est.includes('denegad');
    }).length;
    const pendientesCount = totalCount - entregadasCount - rechazadasCount;

    // Filter requests
    const filteredSolicitudes = solicitudes.filter(s => {
        const est = (s.status || 'Pendiente').toLowerCase();
        const isEntregada = est === 'accepted' || est.includes('entregad') || est.includes('aprobad');
        const isRechazada = est === 'rejected' || est.includes('rechazad') || est.includes('denegad');
        const isPendiente = !isEntregada && !isRechazada;

        if (filterStatus === 'ENTREGADA' && !isEntregada) return false;
        if (filterStatus === 'RECHAZADA' && !isRechazada) return false;
        if (filterStatus === 'PENDIENTE' && !isPendiente) return false;

        if (searchTerm.trim()) {
            const query = searchTerm.toLowerCase();
            const tipo = (s.tipo || '').toLowerCase();
            const motivo = (s.motivo || '').toLowerCase();
            const statusStr = (s.status || '').toLowerCase();
            const id1xbet = (s.id1xbet || s.id || '').toString().toLowerCase();

            return (
                tipo.includes(query) ||
                motivo.includes(query) ||
                statusStr.includes(query) ||
                id1xbet.includes(query)
            );
        }

        return true;
    });

    return (
        <Nlayout>
            <div className="rankings-container" style={{ paddingTop: '80px', paddingBottom: '60px', minHeight: '85vh' }}>
                <div className="rankings-content" style={{ maxWidth: '1100px', margin: '0 auto', padding: isMobile ? '0 12px' : '0 24px' }}>

                    {/* Header */}
                    <div className="rankings-header" style={{ marginBottom: '28px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', justifyContent: 'center', marginBottom: '8px' }}>
                            <div style={{
                                width: '48px',
                                height: '48px',
                                borderRadius: '14px',
                                background: 'linear-gradient(135deg, rgba(168, 85, 247, 0.2) 0%, rgba(59, 130, 246, 0.2) 100%)',
                                border: '1px solid rgba(168, 85, 247, 0.3)',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                            }}>
                                <TbReceipt style={{ fontSize: '26px', color: '#a855f7' }} />
                            </div>
                            <h1 className="rankings-title" style={{ margin: 0, fontSize: isMobile ? '1.8rem' : '2.4rem' }}>
                                Mis Solicitudes
                            </h1>
                        </div>
                        <p style={{
                            textAlign: 'center',
                            color: 'rgba(255, 255, 255, 0.6)',
                            fontFamily: 'Outfit, sans-serif',
                            fontSize: '0.95rem',
                            marginTop: '6px',
                            marginBottom: '24px'
                        }}>
                            Historial detallado de todas tus solicitudes realizadas en el sitio
                        </p>
                    </div>

                    {/* Telegram Verification Banner */}
                    <Box sx={{ mb: 3 }}>
                        <TelegramVerificationCard username={nombre} />
                    </Box>

                    {/* Metric Cards */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        <Grid item xs={6} sm={3}>
                            <Box sx={{
                                backgroundColor: 'rgba(18, 22, 36, 0.75)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(255, 255, 255, 0.08)',
                                borderRadius: '16px',
                                p: 2,
                                textAlign: 'center',
                                transition: 'transform 0.2s',
                                '&:hover': { transform: 'translateY(-2px)' }
                            }}>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.8rem', color: 'rgba(255, 255, 255, 0.5)', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Total
                                </Typography>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '1.8rem', fontWeight: 800, color: '#ffffff', mt: 0.5 }}>
                                    {totalCount}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Box sx={{
                                backgroundColor: 'rgba(18, 22, 36, 0.75)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(0, 255, 115, 0.2)',
                                borderRadius: '16px',
                                p: 2,
                                textAlign: 'center',
                                transition: 'transform 0.2s',
                                '&:hover': { transform: 'translateY(-2px)' }
                            }}>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.8rem', color: '#00ff73', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Entregadas
                                </Typography>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '1.8rem', fontWeight: 800, color: '#00ff73', mt: 0.5 }}>
                                    {entregadasCount}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Box sx={{
                                backgroundColor: 'rgba(18, 22, 36, 0.75)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(245, 158, 11, 0.2)',
                                borderRadius: '16px',
                                p: 2,
                                textAlign: 'center',
                                transition: 'transform 0.2s',
                                '&:hover': { transform: 'translateY(-2px)' }
                            }}>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.8rem', color: '#f59e0b', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Pendientes
                                </Typography>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '1.8rem', fontWeight: 800, color: '#f59e0b', mt: 0.5 }}>
                                    {pendientesCount}
                                </Typography>
                            </Box>
                        </Grid>
                        <Grid item xs={6} sm={3}>
                            <Box sx={{
                                backgroundColor: 'rgba(18, 22, 36, 0.75)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(239, 68, 68, 0.2)',
                                borderRadius: '16px',
                                p: 2,
                                textAlign: 'center',
                                transition: 'transform 0.2s',
                                '&:hover': { transform: 'translateY(-2px)' }
                            }}>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.8rem', color: '#ef4444', fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                    Rechazadas
                                </Typography>
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '1.8rem', fontWeight: 800, color: '#ef4444', mt: 0.5 }}>
                                    {rechazadasCount}
                                </Typography>
                            </Box>
                        </Grid>
                    </Grid>

                    {/* Filter and Search Bar */}
                    <Box sx={{
                        display: 'flex',
                        flexDirection: isMobile ? 'column' : 'row',
                        gap: 2,
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        mb: 3,
                        backgroundColor: 'rgba(18, 22, 36, 0.5)',
                        p: 2,
                        borderRadius: '16px',
                        border: '1px solid rgba(255, 255, 255, 0.06)'
                    }}>
                        {/* Status Tabs */}
                        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', width: isMobile ? '100%' : 'auto' }}>
                            {[
                                { id: 'ALL', label: `Todas (${totalCount})` },
                                { id: 'PENDIENTE', label: `Pendientes (${pendientesCount})` },
                                { id: 'ENTREGADA', label: `Entregadas (${entregadasCount})` },
                                { id: 'RECHAZADA', label: `Rechazadas (${rechazadasCount})` }
                            ].map(tab => (
                                <button
                                    key={tab.id}
                                    onClick={() => setFilterStatus(tab.id)}
                                    style={{
                                        fontFamily: 'Outfit, sans-serif',
                                        fontSize: '0.82rem',
                                        fontWeight: 700,
                                        padding: '7px 14px',
                                        borderRadius: '10px',
                                        border: filterStatus === tab.id
                                            ? '1px solid rgba(168, 85, 247, 0.5)'
                                            : '1px solid rgba(255, 255, 255, 0.08)',
                                        backgroundColor: filterStatus === tab.id
                                            ? 'rgba(168, 85, 247, 0.2)'
                                            : 'rgba(255, 255, 255, 0.03)',
                                        color: filterStatus === tab.id ? '#ffffff' : 'rgba(255, 255, 255, 0.6)',
                                        cursor: 'pointer',
                                        transition: 'all 0.2s',
                                        flex: isMobile ? 1 : 'none',
                                        textAlign: 'center'
                                    }}
                                >
                                    {tab.label}
                                </button>
                            ))}
                        </Box>

                        {/* Search Box */}
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            backgroundColor: 'rgba(255, 255, 255, 0.04)',
                            border: '1px solid rgba(255, 255, 255, 0.1)',
                            borderRadius: '10px',
                            px: 1.5,
                            py: 0.8,
                            width: isMobile ? '100%' : '240px'
                        }}>
                            <TbSearch style={{ color: 'rgba(255, 255, 255, 0.4)', fontSize: '18px' }} />
                            <input
                                type="text"
                                placeholder="Buscar solicitud..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                style={{
                                    background: 'transparent',
                                    border: 'none',
                                    outline: 'none',
                                    color: '#ffffff',
                                    fontFamily: 'Outfit, sans-serif',
                                    fontSize: '0.85rem',
                                    width: '100%'
                                }}
                            />
                        </Box>
                    </Box>

                    {/* Table / List */}
                    <div className="rankings-table-container">
                        {loading ? (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 8 }}>
                                <CircularProgress sx={{ color: '#a855f7' }} />
                            </Box>
                        ) : filteredSolicitudes.length === 0 ? (
                            <Box sx={{ textAlign: 'center', py: 6, px: 2 }}>
                                <TbReceipt style={{ fontSize: '48px', color: 'rgba(255, 255, 255, 0.2)', marginBottom: '12px' }} />
                                <Typography sx={{ fontFamily: 'Outfit, sans-serif', color: 'rgba(255, 255, 255, 0.5)', fontSize: '1rem' }}>
                                    {solicitudes.length === 0
                                        ? "Aún no tenés solicitudes registradas."
                                        : "No se encontraron solicitudes con los filtros aplicados."}
                                </Typography>
                            </Box>
                        ) : (
                            <table className="rankings-table">
                                <thead>
                                    <tr>
                                        <th style={{ width: '60px' }}>#</th>
                                        <th>Fecha</th>
                                        <th>Tipo</th>
                                        <th>Dirección BnB</th>
                                        <th>Estado</th>
                                        <th style={{ textAlign: 'right' }}>Detalles / Motivo</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredSolicitudes.map((item, index) => {
                                        const fecha = item.createdAt
                                            ? new Date(item.createdAt).toLocaleString('es-AR', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit'
                                            })
                                            : '—';

                                        const estado = (item.status || 'Pendiente').trim();
                                        const estadoLower = estado.toLowerCase();
                                        const isEntregada = estadoLower === 'accepted' || estadoLower.includes('entregad') || estadoLower.includes('aprobad');
                                        const isRechazada = estadoLower === 'rejected' || estadoLower.includes('rechazad') || estadoLower.includes('denegad');

                                        const estadoColor = isEntregada ? '#00ff73' : isRechazada ? '#ef4444' : '#f59e0b';
                                        const estadoBg = isEntregada ? 'rgba(0, 255, 115, 0.12)' : isRechazada ? 'rgba(239, 68, 68, 0.12)' : 'rgba(245, 158, 11, 0.12)';
                                        const estadoBorder = isEntregada ? 'rgba(0, 255, 115, 0.3)' : isRechazada ? 'rgba(239, 68, 68, 0.3)' : 'rgba(245, 158, 11, 0.3)';

                                        const IconoEstado = isEntregada ? TbCheck : isRechazada ? TbX : TbClock;

                                        const tipoLabel = item.tipo === 'apelacion' || item.casino === 'blacklist' ? 'Apelación Blacklist' : (item.tipo === '1xBet' ? 'Solicitud 1xBet' : item.tipo === 'Bonus' ? 'Solicitud Bonus' : item.tipo ? `Solicitud ${item.tipo}` : 'Solicitud Bonos');

                                        return (
                                            <tr key={item._id || item.id || index}>
                                                <td className="cell-rank" style={{ color: 'rgba(255, 255, 255, 0.4)', fontWeight: 600 }}>
                                                    #{index + 1}
                                                </td>
                                                <td>
                                                    <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.88rem', color: '#ffffff', fontWeight: 500 }}>
                                                        {fecha}
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                        <Chip
                                                            label={tipoLabel}
                                                            size="small"
                                                            sx={{
                                                                fontFamily: 'Outfit, sans-serif',
                                                                fontWeight: 700,
                                                                fontSize: '0.78rem',
                                                                backgroundColor: 'rgba(168, 85, 247, 0.15)',
                                                                color: '#c084fc',
                                                                border: '1px solid rgba(168, 85, 247, 0.3)'
                                                            }}
                                                        />
                                                    </Box>
                                                </td>
                                                <td>
                                                    <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.88rem', color: 'rgba(255, 255, 255, 0.8)' }}>
                                                        {item.bnbAddress || item.usuario1xbet || item.cuenta || '—'}
                                                    </Typography>
                                                </td>
                                                <td>
                                                    <Box sx={{
                                                        display: 'inline-flex',
                                                        alignItems: 'center',
                                                        gap: 0.6,
                                                        px: 1.2,
                                                        py: 0.4,
                                                        borderRadius: '8px',
                                                        backgroundColor: estadoBg,
                                                        border: `1px solid ${estadoBorder}`,
                                                    }}>
                                                        <IconoEstado style={{ color: estadoColor, fontSize: '14px' }} />
                                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.82rem', fontWeight: 700, color: estadoColor }}>
                                                            {estado}
                                                        </Typography>
                                                    </Box>
                                                </td>
                                                <td style={{ textAlign: 'right' }}>
                                                    {isRechazada && item.motivo ? (
                                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.85rem', color: '#fca5a5', fontStyle: 'italic' }}>
                                                            Motivo: {item.motivo}
                                                        </Typography>
                                                    ) : (
                                                        <Typography sx={{ fontFamily: 'Outfit, sans-serif', fontSize: '0.82rem', color: 'rgba(255, 255, 255, 0.4)' }}>
                                                            {isEntregada ? 'Procesada correctamente' : 'En revisión por el equipo'}
                                                        </Typography>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        )}
                    </div>
                </div>
            </div>
        </Nlayout>
    );
}
